import { get } from 'es-toolkit/compat';

type State = {
  inFlightInit: Promise<void> | null;
  loading: boolean;
  resetToken?: number;
} & Record<string, unknown>;

export async function initOnce<TResult>(
  key: string,
  setState: (state: Partial<State>) => void,
  getState: () => State,
  loader: () => Promise<TResult>,
  onSuccess: (result: TResult) => void
): Promise<void> {
  const state = getState();

  if (get(state, key)) {
    return;
  }

  const inFlight = state.inFlightInit;
  if (inFlight) {
    await inFlight;
    return;
  }

  // Captured so a reset() mid-flight can invalidate this task's result before it commits.
  const tokenAtStart = state.resetToken ?? 0;

  const task = (async () => {
    setState({ loading: true });

    try {
      const result = await loader();

      if ((getState().resetToken ?? 0) !== tokenAtStart) {
        return;
      }

      onSuccess?.(result);
    } finally {
      if ((getState().resetToken ?? 0) === tokenAtStart) {
        setState({ inFlightInit: null, loading: false });
      }
    }
  })();

  setState({ inFlightInit: task });
  await task;
}
